

const validateError = (error) => {

    try {

        if (error && error.response && error.response.data && error.response.data) {

            const vlevel = error.response.data.RES_LEVEL;

            if (vlevel == 1 || vlevel == 2) {
                const result = error.response.data.RES_RESULT;

                if (result && result.ERROR_FLAG) {
                    return error.response.data.RES_RESULT.RES_MESSAGE;
                } else if (!result) {
                    return error.response.data.RES_MESSAGE;
                }
            } else {
                return "Ans unexpected error has occurred, make sure all fields are filled out";
            }
        }
    } catch (error) {

        console.log(error);
    }
    return "An unexpected error has occurred, make sure all fields are filled out";
}

export default validateError;